module.exports = __webpack_public_path__ + "static/media/Crabs.69b23281.JPG";